import AdminPage from '../../components/AdminPage';

const SegmentDetail = () => (
  <AdminPage title='Segment'>
    <p>Segment Detail</p>
  </AdminPage>
);

export default SegmentDetail;
